import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomDirectionality } from '@ui';
import { AuthService } from './auth.service';
import { UserSettingsModels } from '@share-models';
import { LocalStorageKeys } from '../consts/shared.const';
import { SessionStorageService } from '@ui';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  constructor(
    private translate: TranslateService,
    private overlayContainer: OverlayContainer,
    private directionality: CustomDirectionality,
    private authService: AuthService,
    private sessionStorageService: SessionStorageService,
  ) {}

  public setLanguage(lang: string): void {
    this.sessionStorageService.setItem(LocalStorageKeys.LANGUAGE, lang);
    this.translate.use(lang);
    document.documentElement.lang = lang;
    const isRtl = lang === 'he';
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    const htmlDir = document.documentElement.getAttribute('dir');

    if (htmlDir) {
      this.overlayContainer.getContainerElement().setAttribute('dir', htmlDir);
      this.directionality.setDirection(isRtl ? 'rtl' : 'ltr');
    }
  }

  public initLanguage(): void {
    if (!this.authService.isLoggedIn()) {
      const interfaceLanguage = this.sessionStorageService.getItem(
        LocalStorageKeys.LANGUAGE,
      );
      this.setLanguage(
        interfaceLanguage ?? UserSettingsModels.LANGUAGE.ENGLISH,
      );
    }
  }
}
